module.exports = __webpack_public_path__ + "cebf461f6118415f351d519db420111f.jpg";